import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Options } from 'src/app/core/models/Options.model';

@Component({
  selector: 'app-fatca-pep-page',
  templateUrl: './fatca-pep-page.component.html',
  styleUrls: ['./fatca-pep-page.component.less']
})
export class FatcaPepPageComponent implements OnInit {

  public isUSPerson: Boolean = false; 
  public isPEPPerson: Boolean = false;
  public isPEPRelated: Boolean = false;

  public usOptions: Array<Options> =[];

  public usFormGroup!: FormGroup;   
  public PEPFormGroup!: FormGroup;
  public PEPRelativeFormGroup! : FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeFormGroup();
    this.initializeOptions();
    this.addUSOptions();

  }

  //#region Form Group Evenets
  initializeFormGroup(){
    this.PEPFormGroup = new FormGroup({
      govAgency: new FormControl('', [Validators.required]),
      position: new FormControl('', [Validators.required]),
      yearsOfService: new FormControl('', [Validators.required])
    });

    this.PEPRelativeFormGroup = new FormGroup({
      relativeName: new FormControl('', [Validators.required]),
      relationship: new FormControl('', [Validators.required]),
      position: new FormControl('', [Validators.required]),
      yearsOfService: new FormControl('', [Validators.required])
    })

    this.usFormGroup = this.formBuilder.group({
      usArray: this.formBuilder.array([])
    })
  }

  initializeOptions(){
    this.usOptions.push(new Options(
      "I am a US Citizen",
      "1",
      false
    ));
  }

  //#region Helper method to get the 'items' FormArray
  get usArray() {
    return this.usFormGroup.controls["usArray"] as FormArray;
  }

  //#region logical Methods 
  notUSPerson(event: any){
    this.isUSPerson = !this.isUSPerson;
    if(this.isUSPerson){
      this.usArray.controls.forEach(control => {control.disable()});
    }
    else{
      this.usArray.controls.forEach(control => {control.enable()});
    }
  }
  
  goBack(){
    this.router.navigateByUrl(`/file-upload/client-onboarding`, { skipLocationChange: false });
  }

  proceed(){

  }
  
  addUSOptions() {
    for(var x = 0; x < this.usOptions.length; x++){
      const item = this.formBuilder.group({
        usText:new FormControl(this.usOptions[x].text),
        usID:new FormControl(this.usOptions[x].value),
        usAnswer: new FormControl(this.usOptions[x].active)
      });
      this.usArray.push(item);
    }
  }
}
